/** 업데이트 소식 문구 — ko/landingReleases.ts 와 같은 키(정본은 ko). */
const landingReleases = {
  "eyebrow": "ព័ត៌មានថ្មីៗ",
  "title": "DroneSquare កាន់តែថ្មី",
  "lead": "ស្គាល់បច្ចេកវិទ្យាការដ្ឋានទំនើបបំផុតមុនគេជាមួយ DroneSquare។",
  "demo": "មើលវីដេអូបង្ហាញ",
  "demoLabel": "មើលវីដេអូបង្ហាញ — {{topic}}",
  "demoStepLabel": "មើលវីដេអូបង្ហាញ — {{topic}} ចាប់ពីជំហានទី {{step}}",
  "artLabel": "រូបភាពគំនិត៖ {{title}}",
  "items": {
    "auto_mapping": {
      "title": "ការស្គាល់ GCP ស្វ័យប្រវត្តិ",
      "description": "ស្វែងរកសញ្ញាស្តង់ដារដោយខ្លួនឯង ហើយផែនទីបានបញ្ចប់ដោយមិនចាំបាច់ធ្វើចំណុចយោង។"
    },
    "equip_sim": {
      "title": "ការក្លែងធ្វើផ្លូវធ្វើដំណើរឧបករណ៍",
      "description": "ធ្វើឱ្យឧបករណ៍ច្រើនគ្រឿងផ្លាស់ទីតាមទំហំពិត ហើយរកឃើញហានិភ័យប៉ះទង្គិចជាមុន។"
    },
    "linear_ew": {
      "title": "ការងារដីផ្អែកលើខ្សែបន្ទាត់",
      "description": "ខ្សែបន្ទាត់តែមួយ គណនាបរិមាណដីជីក និងដីចាក់តាមស្ថានីយនីមួយៗ។"
    },
    "ew_summary": {
      "title": "ការគណនាបរិមាណការងារដី 3D",
      "description": "ប្រៀបធៀបប្លង់ និង 3D ដើម្បីគណនាបរិមាណគម្រោង បានធ្វើ និងនៅសល់ដោយស្វ័យប្រវត្តិ។"
    },
    "folders": {
      "title": "គ្រប់គ្រងទិន្នន័យទាំងអស់ជាថត",
      "description": "ទោះឯកសារច្រើនប៉ុណ្ណា ក៏ដាក់ជាថត ហើយរកឃើញភ្លាមៗ។"
    },
    "walk_roadview": {
      "title": "ផ្លូវមើល 360°",
      "description": "ដើរមើលការដ្ឋានដោយរូបថត 360° ទោះនៅការិយាល័យក៏ដោយ។"
    },
    "history": {
      "title": "ប្រវត្តិគម្រោង",
      "description": "ប្រវត្តិបង្កើត កែប្រែ និងលុប ត្រូវបានរក្សាតាមលំដាប់ពេលវេលា ហើយតាមដានបានភ្លាមៗ។"
    },
    "area_capture": {
      "title": "ការថតតំបន់",
      "description": "កាត់យកតែតំបន់ដែលត្រូវការជារូបភាពគុណភាពខ្ពស់បានភ្លាមៗ។"
    },
    "issue_comments": {
      "title": "មតិលើបញ្ហា",
      "description": "មតិ និងរូបថតការដ្ឋាន ធ្វើឱ្យការដ្ឋាន និងការិយាល័យមើលបញ្ហាដូចគ្នា។"
    },
    "pano360": {
      "title": "កម្មវិធីមើលរូបថត និងវីដេអូ 360°",
      "description": "មើលការដ្ឋានគ្រប់ទិសទីដោយរូបថត និងវីដេអូ 360°។"
    },
    "clip_box": {
      "title": "ឧបករណ៍ផ្នែកកាត់ 3D",
      "description": "កាត់ម៉ូដែល 3D ដើម្បីវាស់ និងកត់ត្រាខាងក្នុងដែលបាំង។"
    },
    "dsm_color": {
      "title": "ពណ៌កម្ពស់ 3D",
      "description": "ពណ៌តាមកម្ពស់ ធ្វើឱ្យខ្ពស់ទាបនៃដីរាង 3D លេចចេញភ្លាមៗ។"
    },
    "vectors": {
      "title": "វ៉ិចទ័រ 3D ដោយកូអរដោនេ",
      "description": "ខ្សែ 3D ត្រូវបានគូរលើការដ្ឋានតាមកូអរដោនេរចនាយ៉ាងត្រឹមត្រូវ។"
    },
    "workers": {
      "title": "តាមដានទីតាំងកម្មករ",
      "description": "មើលទីតាំងកម្មករក្នុងពេលជាក់ស្ដែង ហើយជូនដំណឹងភ្លាមពេលចូលតំបន់ហាមឃាត់។"
    },
    "first_person": {
      "title": "ការហោះហើរទស្សនៈបុគ្គលទីមួយ",
      "description": "ហោះក្នុងការដ្ឋាន 3D ហើយពិនិត្យគ្រប់ជ្រុង។"
    },
    "geolog_map": {
      "title": "GeoLog",
      "description": "រូបថត និងវីដេអូស្ថិតលើផែនទី នៅកន្លែងដែលបានថតពិតប្រាកដ។"
    },
    "ja": {
      "title": "គាំទ្រភាសាជប៉ុន និងខ្មែរ",
      "description": "គាំទ្រ 4 ភាសា និងល្វែងម៉ោងក្នុងស្រុក ដើម្បីគ្រប់គ្រងការដ្ឋានក្រៅប្រទេសលើអេក្រង់តែមួយ។"
    },
    "dxf_on_3d": {
      "title": "ការត្រួតប្លង់លើ 3D",
      "description": "ត្រួតប្លង់រចនាលើដីរាង 3D ដើម្បីប្រៀបធៀបការរចនា និងការដ្ឋានជាបីវិមាត្រ។"
    },
    "profile_3d": {
      "title": "ក្រាហ្វផ្នែកកាត់បណ្ដោយ និងទទឹង 3D",
      "description": "ពិនិត្យផ្នែកកាត់បណ្ដោយ និងទទឹងនៃម៉ូដែល 3D តាមខ្សែបន្ទាត់បានភ្លាមៗ។"
    }
  }
} as const;

export default landingReleases;
